<nav class="sidebar">

  <!--- Top corner -->
  <div class="sidebar-header">
    <!--- Toggler -->
    <div class="sidebar-toggler active" #sidebarToggler (click)="toggleSidebar($event)">
      <span class="fa fa-chevron-left"></span>
    </div>

    <!--- Logo -->
    <a routerLink="/" class="sidebar-brand nobleui-logo">
      <img id="logo" src="assets/images/logo-app.png" class="logo" alt="Logo" /> 
      <span class="text-whitez px-1">NetLinkDeal</span>
    </a>
  </div>

  <!--- Sidemenu start -->
  <div class="sidebar-body" (mouseenter)="operSidebarFolded()" (mouseleave)="closeSidebarFolded()" [perfectScrollbar]>
    <ul class="sidebar-nav metismenu" id="sidebar-menu" #sidebarMenu *ngIf="menuItems">
      
      <!-- MENU -->
      <ng-container *ngFor="let item of menuItems">
        <!-- titre -->
        <li class="nav-item nav-category" *ngIf="item.isTitle && item.isLocked != false">{{ item.label }}</li>
    
        <!-- non titre -->
        <li class="nav-item" *ngIf="!item.isTitle && item.isLocked != false" >
          <a class="nav-link" *ngIf="hasItems(item)" href="javascript:void(0);">
            <i class="link-icon {{item.icon}}" *ngIf="item.icon"></i>
            <span class="link-title"> {{ item.label }}</span>
            <span class="link-arrow" data-feather="chevron-down" appFeatherIcon></span>
          </a>
    
          <a class="nav-link nav-link-ref {{ item.highlight ? item.highlight?.styleClass : '' }}" [routerLink]="item.link" *ngIf="!hasItems(item)"
            [attr.data-parent]="item.parentId">
            <i class="link-icon {{item.icon}}" *ngIf="item.icon"></i>
            <span class="link-title position-relative"> 
              {{ item.label }} 
              <span *ngIf="item.badge?.text" class="fa-stack count-badge">
                <span class="fa fa-circle fa-stack-2x text-{{item.badge.variant}}"></span>
                <span class="fa fa-stack-1x text-info">{{item.badge.text}}</span>
              </span> 
            </span>
          </a>
    
          <ul class="sidebar-nav sub-menu nav-second-level" *ngIf="hasItems(item)" aria-expanded="false">
    
            <li class="nav-item" *ngFor="let subitem of item.subItems" [ngClass]="{'side-nav-item': hasItems(subitem)}">
              <a class="nav-link side-nav-link-a-ref" *ngIf="hasItems(subitem)" href="javascript:void(0);">
                <i class="link-icon {{subitem.icon}}" *ngIf="subitem.icon"></i>
                <span class="link-title"> {{ subitem.label }}</span>
                <span class="link-arrow" data-feather="chevron-down" appFeatherIcon></span>
              </a>
    
              <a class="nav-link nav-link-ref" [routerLink]="subitem.link" *ngIf="!hasItems(subitem)"
                [attr.data-parent]="subitem.parentId">
                <i class="link-icon {{subitem.icon}}" *ngIf="subitem.icon"></i>
                {{ subitem.label }}
              </a>
    
              <ul class="sidebar-nav sub-menu nav-third-level" *ngIf="hasItems(subitem)" aria-expanded="false">
                <li class="nav-item" *ngFor="let subSubitem of subitem.subItems">
                  <a class="nav-link nav-link-ref" [routerLink]="subSubitem.link" [routerLinkActive]="['active']"
                    [attr.data-parent]="subSubitem.parentId">
                    <i class="link-icon {{subitem.icon}}" *ngIf="subitem.icon"></i>
                    {{ subSubitem.label }}
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ng-container>

      <!-- SUPPORT -->
      <ng-container *ngIf="accessLink()">
        <!-- titre support -->
        <li class="nav-item nav-category" translate>Support</li>

        <!-- link support -->
        <li class="nav-item">
          <a class="nav-link" (click)="onLinkClick()">
            <i class="link-icon fa fa-envelope"></i>
            <span class="link-title" translate> Contact Us</span>
          </a>
        </li>
      </ng-container>

    </ul>
  </div>
</nav>